module.exports = {
	'support.m5.m510010.wf110': {
		'theSamePersonIsTransferredTo': '同一人調同天班',
		'theSamePersonTunesDifferentDays': '同一人調不同天班',
		'transferShiftsWithOthers': '與他人調班',
		'supportForScheduling': '支援排班',
		'theSamePersonCanBeTransferred': '可新增/刪除/編輯班別資訊',
		'theSamePersonCanBeTransferred2': '僅可調換班別資訊',
		'shiftWithAnotherPersonCanOnly': '僅可調換班別資訊',
		'supportSchedulingCrossOrganizationSupportFor': '跨單位支援排班',
		'timeCheckErrors': '工時檢查錯誤：',
		'originalShift': '原排班資訊',
		'theDateShifts': '您想調班的日期',
		'shiftBtn1': '調班日期 1',
		'shiftBtn2': '調班日期 2',
		'recalculate': '重新計算',
		'scheduledShifts': '已排班別',
		'supportShift': '支援班別',
		'viewShiftSchedule': '查看班表',
	},
	'support.errorByDateCheck': {
		'A14': '調班員工調班日期不在職',
		'B14': '對調人員對調日期不在職',
		'A31': '檢查錯誤：該日已排班別的數量已超過每日最大可排班別數',
		'B31': '檢查錯誤：該日已排班別的數量已超過每日最大可排班別數',
		'A32': '檢查錯誤：已超過班表異動期限',
		'B32': '檢查錯誤：已超過班表異動期限',
		'A33': '檢查錯誤：僅可異動「班別排班」或「時段排班」的班別',
		'B33': '檢查錯誤：僅可異動「班別排班」或「時段排班」的班別',
		'A34': '檢查錯誤：僅可異動相同班別屬性的班別',
		'B34': '檢查錯誤：僅可異動相同班別屬性的班別',
		'A35': '檢查錯誤：所選日期已工時結算',
		'B35': '檢查錯誤：所選日期已工時結算',
		'A36': '檢查錯誤：所選日期有簽核中的調班單',
		'B36': '檢查錯誤：所選日期有簽核中的調班單',
	},
	'support.errorByTransferCheck': {
		'A11': '調班員工與對調人員必須相同',
		'A12': '調班日期與對調日期必須相同',
		'A13': '調班員工不存在該公司',
		'B13': '對調人員不存在該公司',
		'A14': '調班員工調班日期不在職',
		'B14': '對調人員對調日期不在職',
		'A15': '調班日期與對調日期不可相同',
		'A16': '調班員工與對調人員不可相同',
		'A17': '調班員工調班後行事曆別與班別標籤不可與現況相同',
		'B17': '對調人員調班後行事曆別與班別標籤不可與現況相同',
		// 'A18': '調班員工調班前行事曆別與班別標籤與現況不相同',
		// 'B18': '對調人員調班前行事曆別與班別標籤與現況不相同',
		'A18': '<%=A%> 在 <%=B%> 的異動前資料已被更改',
		'B18': '<%=A%> 在 <%=B%> 的異動前資料已被更改',
		'A19': '支援排班成本中心不可為空',
		'A20': '調班日期與對調日期的曆日時間不同',
		'A23': '支援排班成本中心加總不為100%',
		'A24': '支援排班成本中心ID不存在本公司',
		'A25': '調班ID不存在本公司',
		'A26': '公司表單不存在本公司',
		'A27': '調班員工調班後的班別ID不存在本公司',
		'B27': '對調人員調班後的班別ID不存在本公司',
		'A28': '調班員工調班後的標籤ID不存在本公司',
		'B28': '對調人員調班後的標籤ID不存在本公司',
		'A31': '調班員工已排班別不可大於每日可排班別數',
		'B31': '對調人員已排班別不可大於每日可排班別數',
		'A32': '調班員工調班日期不在班表異動期限內',
		'B32': '對調人員對調日期不在班表異動期限內',
		'A33': '調班員工調班日期的班別屬性非「排班(依班別)」或「排班(依時段)」',
		'B33': '對調人員對調日期的班別屬性非「排班(依班別)」或「排班(依時段)」',
		// 'A34': '調班員工調班日期班別屬性不同',
		// 'B34': '對調人員對調日期班別屬性不同',
		'A34': '<%=A%> 在 <%=B%> 的班別屬性已異動',
		'B34': '<%=A%> 在 <%=B%> 的班別屬性已異動',
		'A35': '調班員工調班日期已工時結算',
		'B35': '對調人員對調日期已工時結算',
		'A36': '調班員工調班日期有「簽核中」調班單',
		'B36': '對調人員對調日期有「簽核中」調班單',
		'A37': '已不開放此申請類型',
		'A38': '可異動項目未開放',
		// 'A39': '調班員工調班日期工作時間重疊',
		// 'B39': '對調人員對調日期工作時間重疊',
		'A39': '<%=A%> 在 <%=B%> 的 <%=C%> 與 <%=E%> 工作時間重疊',
		'B39': '<%=A%> 在 <%=B%> 的 <%=C%> 與 <%=E%> 工作時間重疊',
		'A40': '調班員工調班日期不符合工時規則(提醒)',
		'B40': '對調人員對調日期不符合工時規則(提醒)',
		'A41': '調班員工調班日期不符合工時規則(禁止)',
		'B41': '對調人員對調日期不符合工時規則(禁止)',
		// 'A42': '調班員工調班日期超過調班次數限制',
		// 'B42': '對調人員對調日期超過調班次數限制',
		'A42': '<%=A%> 在 <%=B%> ~ <%=C%> 的調班次數已達上限',
		'B42': '<%=A%> 在 <%=B%> ~ <%=C%> 的調班次數已達上限',
	},
	'support.errorByTransferResend': {
		'A14': '調班員工調班日期不在職',
		'B14': '對調人員對調日期不在職',
		'A31': '該日已排班別的數量已超過每日最大可排班別數',
		'B31': '該日已排班別的數量已超過每日最大可排班別數',
		'A32': '已超過班表異動期限',
		'B32': '已超過班表異動期限',
		'A33': '僅可異動「班別排班」或「時段排班」的班別',
		'B33': '僅可異動「班別排班」或「時段排班」的班別',
		'A34': '班別屬性已異動',
		'B34': '班別屬性已異動',
		'A35': '班別已工時結算',
		'B35': '班別已工時結算',
		'A36': '已有相同日期的簽核中表單',
		'B36': '已有相同日期的簽核中表單',
		'A37': '已不開放此申請類型',
		'B37': '已不開放此申請類型',
		'notInChangeableEmpIds': '已不符合可申請的異動對象',
	},
	'support.errorByInsertShift': {
		'11': '「工作時間」必填未填',
		'12': '工作時間重疊',
		'13': '休息時間與多個班別工作時間重疊',
		'14': '休息時間重疊',
		'15': '「工作時間」結束時間早於起始時間',
		'16': '「休息時間」結束時間早於起始時間',
		'17': '曆日資料有誤',
		'18': '「工作時間」結束時間不可等於起始時間',
		'19': '「休息時間」結束時間不可等於起始時間',
	},
	'support.m5.m510010.wf110_common': {
		'areYouSureYouWantTo': '確定要恢復預設值？',
		'restoreDefaultValues': '恢復預設值',
	},
	'support.service.m5.service-m510010_wf110': {
		'theDataHasBeenChangedBefore': '<%=temp1%> 在 <%=temp2%> 的異動前資料已被更改',
		'calendarIsRequired': '行事曆別為必填欄位',
		'noSpecificWorkingHoursSet': '未自訂任何工作時間',
		'reasonIsRequired': '需要填寫原因',
		'attachmentIsRequired': '需要提供附件',
	},
	'support.m5.m510010.wf110_rows': {
		'adjusted': '已調整',
		'checkOutTheSchedule': '查看班表',
		'leaveInformation': '假勤資訊',
		'overtimeInformation': '加班資訊',
		'leaveStr': '請假：<%=n%> <%=unit%>',
		'leaveCancelStr': '銷假：<%=n%> <%=unit%>',
		'overtimeStr': '加班：<%=n%> <%=unit%>',
	},
	'support.m5.preview.wf110': {
		'shiftAfterShift': '調班後班別',
		'thePeriodAfterTheShift': '調班後工作時間',
	},
	'support.m5.details.wf110': {
		'breakTimeAfterShifting': '調班後休息時間',
		'aTotalOfShifts': '調班共 <%=temp1%> 個',
		'aTotalOfTransactionsAreSupported': '支援班別共 <%=temp1%> 個',
		'aTotalOfScheduledShift': '已排班别共 <%=temp1%> 個',
	},
	'support.m5.m510010.wf110.download': {
		'shiftPersonnel': '調班人員',
		'scheduledWorkingHours': '當日已排工作時數',
		'workingHours': '工作時間',
		'restTime': '休息時間',
		'costCenter': '(成本中心：<%=temp%>)',
	},
	'support.sp_sa_emp_transfer_CheckDelete': {
		'11': '調班資料不存在本公司',
		'12': '表單狀態必須為在途才能刪除',
	},
	'support.m5.m510010.wf110_support': {
		'scheduledBreaks': '已排休息時間',
	},
};
